<template>
    <div class="card">
        <span v-if="closeByDateTimeString < todayDateTimeString" class="blob"></span>
        <p class="lines_of_business">{{ business_line }}</p>
        <p class="company">{{ company }}</p>
        <p class="annual_value">{{ value }}</p>
    </div>
</template>

<script>
    export default {
        name: 'BoardCard',
        props: {
            company: String,
            business_line: String,
            value: String,
            closeBy: String
        },
        computed: {
            closeByDateTimeString: function() {
                return new Date(this.closeBy).getTime();
            },
            todayDateTimeString: function() {
                let dateObj = new Date();
                let month = dateObj.getUTCMonth() + 1;
                let day = dateObj.getUTCDate();
                let year = dateObj.getUTCFullYear();

                return new Date(year + '/' + month + '/' + day).getTime();
            }
        }
    }
</script>

<style lang="scss" scoped>
    .card{
        position: relative;
        background-color: #fff;
        padding: 1rem 1.5rem;
        margin-top: 2rem;
        border-radius: 0.5rem;
        box-shadow: 2px 2px 5px 0px rgba(0, 0, 0, 0.2);

        .blob {
            position: absolute;
            top: 0.75rem;
            right: 0.75rem;
            width: 1rem;
            height: 1rem;
            background-color: #ff0000;
            border-radius: 100%;
        }

        .company{
            font-size: 1.8rem;
            font-weight: 700;
            line-height: 1.3;
            color: $primary-one;
        }

        .lines_of_business{
            font-size: 1.4rem;
            font-weight: 500;
            line-height: 1.3;
            color: $primary-one;

            margin-bottom: 1rem;
        }

        .annual_value{
            font-size: 1.8rem;
            font-weight: 500;
            line-height: 1.3;
            color: $primary-one;
        }
    }
</style>